import { useSearchParams } from 'react-router-dom';

import {
  useFilteredTemplatesListQuery,
  useTemplateSectionsQuery,
  WaypointTemplateType,
} from '@dashboard/generated/wp/platform';

export function useCurrentTemplateSections() {
  return useTemplateSectionsQuery();
}

export function useCurrentTemplatesQuery() {
  const [params] = useSearchParams();
  const pageValue = params.get('page');
  const typeValue = params.get('type');

  return useFilteredTemplatesListQuery({
    fetchPolicy: 'network-only',
    variables: {
      type: typeValue === 'LAYOUT' ? WaypointTemplateType.Layout : WaypointTemplateType.Template,
      page: pageValue === null ? undefined : parseInt(pageValue, 10),
    },
  });
}
